Vendd.Scripts.load(function () {
    var $wrapper = $('.x-product-details'),
        wrapper;
    var model = null,
        firstLoad = true;

    if ($wrapper.length < 1)
        return;

    wrapper = $wrapper.get(0);

    //example: bundleItems: [{bundleProductId:'testValue', parentProductId:'testValue', productId:'testValue', quantity: 'testValue'}]
    var bundleItems = [];

    var $bundleItems = $('.js-bundle-item-list .js-bundle-item', $wrapper);
    $.each($bundleItems, function (i, control) {
        var $control = $(control);
        var isDynamic = $control.data('is-dynamic').toLowerCase() === 'true';
        var bundleProductId = parseInt($control.data('bundle-id'));
        var parentProductId = $control.data('parent-id');
        var productId = $control.data('selected-id');

        var $qty = $('.js-quantity', $control);

        if (isDynamic) {
            bundleItems.push({
                bundleProductId: bundleProductId,
                parentProductId: parentProductId,
                productId: productId,
                quantity: parseInt($qty.val())
            });
        }
    });

    /* enable add to wishlist, when the version's selectors are selected */
    var $versionSelector = $('.x-product-details-version-selector[data-type="dropdown"]', $wrapper);
    var allVersionsSelected = true;

    $.each($versionSelector, function (i, control) {
        var $control = $(control);

        if ($('.js-selector', $control).val() == '0') {
            allVersionsSelected = false;
            return false;
        }
    });

    if (allVersionsSelected) {
        $('.availability-container', $wrapper).addClass('visible');
        $('.js-add-to-wishlist', $wrapper).removeClass('disabled');
    }

    var recipeItems = [];
    var comboItems = [];
    var minQuantity = ($wrapper.data('min-quantity') ? stringToNumber($wrapper.data('min-quantity')) : null) || 0;
    var maxQuantity = ($wrapper.data('max-quantity') ? stringToNumber($wrapper.data('max-quantity')) : null) || 0;
    var quanta = ($wrapper.data('quanta') ? stringToNumber($wrapper.data('quanta')) : null) || 0;
    var qty = Vendd.Helpers.isInteger(parseFloat(quanta)) ? parseInt(minQuantity).toFixed(0) || 1 : parseFloat(minQuantity).toFixed(2) || 1;

    Vendd.Product.Controller.initState({
        serviceConfiguration: $('.configuration', $wrapper).text(),
        parentId: $wrapper.data('parent-id'),
        selectedId: $wrapper.data('selected-id'),
        selectedColorId: $wrapper.data('selected-color-id'),
        path: $wrapper.data('path'),
        languageId: $wrapper.data('language-id'),
        qty: qty > 0 ? qty : 1,
        minQuantity: Vendd.Helpers.isInteger(parseFloat(quanta)) ? parseInt(minQuantity) : parseFloat(minQuantity),
        maxQuantity: Vendd.Helpers.isInteger(parseFloat(quanta)) ? parseInt(maxQuantity) : parseFloat(maxQuantity),
        quanta: Vendd.Helpers.isInteger(parseFloat(quanta)) ? parseInt(quanta) : parseFloat(quanta),
        bundleItems: bundleItems,
        recipeItems: recipeItems,
        comboItems: comboItems
    });

    $('.configuration', $wrapper).remove();

    wrapper.loading = function (loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        };
    };

    wrapper.bind = function () {

        if ($wrapper.hasClass('x-product-details-popup')) {

            Vendd.MessageBus.publish(wrapper, new Vendd.Widget.Messages.BindControl($('.x-product-details-ajax-buttons', $wrapper)));

        } else {

            var scrollOffset;
            if ($('.js-go-to-size-guide').length > 0) {

                $('.js-go-to-size-guide', $wrapper).click(function () {
                    scrollOffset = $(window).width() > 960 ? 130 : 50;
                    $('.product-details-region .x-tab-panel .tab-title.size-guide').trigger('click');
                    $('html, body').animate({ scrollTop: $('.product-details-region .x-tab-panel .tab-content.size-guide').offset().top - scrollOffset }, 1);
                });
            }

            if ($('.js-scroll-to-reviews').length > 0) {

                $('.js-scroll-to-reviews', $wrapper).click(function () {
                    scrollOffset = $(window).width() > 960 ? 130 : 50;
                    $('.product-details-region .x-tab-panel .tab-title.reviews').trigger('click');
                    $('html, body').animate({ scrollTop: $('.product-details-region .x-tab-panel .tab-content.reviews').offset().top - scrollOffset }, 1);
                });
            }

            if ($('.js-scroll-to-review-form').length > 0) {

                $('.js-scroll-to-review-form', $wrapper).click(function () {
                    scrollOffset = $(window).width() > 960 ? 130 : 50;
                    $('.product-details-region .x-tab-panel .tab-title.reviews').trigger('click');
                    $('html, body').animate({ scrollTop: $('.product-details-region .x-tab-panel .tab-content.reviews').offset().top - scrollOffset }, 1);
                    $('[data-click="open-product-review-form"]').trigger('click');
                });
            }

            Vendd.MessageBus.publish(wrapper, new Vendd.Widget.Messages.BindControl($('.x-product-list', $wrapper)));
        }

        initTooltips();
        scrollToSection();

        Vendd.MessageBus.publish(wrapper, new Vendd.Product.Messages.BindControl($wrapper));
        formatPrices($wrapper);
        allowOnlyNumbersInput($wrapper);

        /* Already in wishlist start | First Load */
        if (firstLoad) {
            var wishlistModel = JSON.parse(localStorage.getItem("CurrentWishlistModel"));
            var isInWishlist = false;
            if (wishlistModel) {
                _.each(wishlistModel.Items, function (item) {
                    if (item.VariantId == $wrapper.data('selected-id')) {
                        isInWishlist = true;
                        $('.x-product-details-ajax-buttons .wishlist-button', $wrapper).addClass('already-in-wishlist');
                        return;
                    }
                });
            }
        }
        /* Already in wishlist end | First Load */

        slickAriaFix($('.x-product-details-photo-gallery'), '.image-container');
    };

    wrapper.update = function () {
        wrapper.loading(true);

        firstLoad = false;

        /* Already in wishlist start */
        var wishlistModel = JSON.parse(localStorage.getItem("CurrentWishlistModel"));
        var isInWishlist = false;

        if (wishlistModel) {
            _.each(wishlistModel.Items, function (item) {
                if (item.VariantId == model.SelectedProductId) {
                    isInWishlist = true;
                    model.AlreadyInWishlist = true;
                    return;
                }
            });
        }
        /* Already in wishlist end */

        if (canonicalBreadcrumb) {
            model = $.extend({}, canonicalBreadcrumb, model);
        }

        if (model.Dimensions.length >= 2) {

            /* Dropdown Selectors - On Color Change, Hide the Colors Photogallery */
            //var colorSelector = $('.x-product-details-version-selector select.dim-0-select');
            //if (colorSelector.length > 0) {
            //    _.each(model.Dimensions[0].Versions, function (ver) {
            //        if (ver.Selected) {
            //            model.HideColorsGallery = true;
            //            return;
            //        }
            //    });
            //}
            //var colorSelector = $('.x-product-details-version-selector select.dim-0-select');
            //if (colorSelector.length > 0) {
            //    if (colorSelector.val() == 0) {
            //        _.each(model.Dimensions[0].Versions, function (ver) { ver.Selected = false; });
            //        model.Dimensions[0].DefaultSkuLoaded = true;
            //        model.DefaultSkuLoaded = true;
            //        if (!model.Buttons.CartEnabled) {
            //            var quantitySelector = $('.x-product-details-quantity-selector .js-selector');
            //            $('option', quantitySelector).each(function () {
            //                var quantityElement = {};
            //                quantityElement.Value = $(this).attr('value');
            //                quantityElement.Selected = $(this).attr('selected') !== undefined;
            //                model.Quantities.push(quantityElement);
            //            });
            //            model.Buttons.CartEnabled = true;
            //        }
            //        model.Buttons.HasAddToCart = false;
            //        model.Buttons.HasAddToProductCompare = false;
            //        model.Buttons.HasAddToWishlist = false;
            //        model.AvailabilityNoticationForm.Visible = false;
            //    }
            //}

            //var sizeSelector = $('.x-product-details-version-selector select.dim-1-select');
            //if (sizeSelector.length > 0) {
            //    if (sizeSelector.val() == 0) {
            //        _.each(model.Dimensions[1].Versions, function (ver) { ver.Selected = false; });
            //        model.Dimensions[1].DefaultSkuLoaded = true;
            //        if (!model.Buttons.CartEnabled) {
            //            var quantitySelector = $('.x-product-details-quantity-selector .js-selector');
            //            $('option', quantitySelector).each(function () {
            //                var quantityElement = {};
            //                quantityElement.Value = $(this).attr('value');
            //                quantityElement.Selected = $(this).attr('selected') !== undefined;
            //                model.Quantities.push(quantityElement);
            //            });
            //            model.Buttons.CartEnabled = true;
            //        }
            //        //model.Quantities[0] = { Value: 1, Selected: true };
            //        model.DefaultSkuLoaded = true;
            //        model.Buttons.HasAddToCart = false;
            //        model.Buttons.HasAddToProductCompare = false;
            //        model.Buttons.HasAddToWishlist = false;
            //        model.AvailabilityNoticationForm.Visible = false;
            //    }
            //}
            /* Dropdown Selectors */


            /* List Selectors */
            var colorSelector = $('.x-product-details-version-selector ul.dim-0-list'),
                sizeSelector = $('.x-product-details-version-selector ul.dim-1-list');

            model.colorIsSelected = false;
            model.sizeIsSelected = false;

            if (colorSelector.length > 0 && $('> li.selected', colorSelector).length > 0) {
                model.colorIsSelected = true;
            }

            if (sizeSelector.length > 0 && $('> li.selected', sizeSelector).length > 0) {
                model.sizeIsSelected = true;
            }

            if (colorSelector.length > 0) {
                _.each(model.Dimensions[0].Versions, function (ver) {
                    if (ver.Selected) {
                        model.ColorIsSelected = true;
                        return;
                    }
                });
                if ($('> li.selected', colorSelector).length == 0) {
                    _.each(model.Dimensions[0].Versions, function (ver) { ver.Selected = false; });
                    if (!model.Buttons.CartEnabled) {
                        var quantitySelector = $('.x-product-details-quantity-selector .js-selector');
                        $('option', quantitySelector).each(function () {
                            var quantityElement = {};
                            quantityElement.Value = $(this).attr('value');
                            quantityElement.Selected = $(this).attr('selected') !== undefined;
                            model.Quantities.push(quantityElement);
                        });
                        model.Buttons.CartEnabled = true;
                    }
                    model.ColorIsSelected = false;
                    model.Buttons.HasAddToCart = false;
                    model.Buttons.HasAddToProductCompare = false;
                    model.Buttons.HasAddToWishlist = false;
                    model.AvailabilityNoticationForm.Visible = false;
                } else {
                    if (!model.sizeIsSelected) {
                        _.each(model.Dimensions[0].Versions, function (ver) {
                            ver.Disabled = false;
                        });
                    }
                }
            }

            if (sizeSelector.length > 0) {
                if ($('> li.selected', sizeSelector).length == 0) {
                    //if (sizeSelector.val() == 0) {
                    _.each(model.Dimensions[1].Versions, function (ver) {
                        ver.Selected = false;
                    });
                    if (!model.Buttons.CartEnabled) {
                        var quantitySelector = $('.x-product-details-quantity-selector .js-selector');
                        $('option', quantitySelector).each(function () {
                            var quantityElement = {};
                            quantityElement.Value = $(this).attr('value');
                            quantityElement.Selected = $(this).attr('selected') !== undefined;
                            model.Quantities.push(quantityElement);

                        });
                        model.Buttons.CartEnabled = true;
                    }
                    //model.Quantities[0] = { Value: 1, Selected: true };
                    model.Buttons.HasAddToCart = false;
                    model.Buttons.HasAddToProductCompare = false;
                    model.Buttons.HasAddToWishlist = false;
                    model.AvailabilityNoticationForm.Visible = false;
                } else {
                    if (!model.colorIsSelected) {
                        _.each(model.Dimensions[1].Versions, function (ver) {
                            ver.Disabled = false;
                        });
                    }
                }
            }
            /* List Selectors */
        }


        var html;
        if ($wrapper.hasClass('x-product-details-popup')) {
            model.IsPopUp = true;
            //model.ProductControllerData.ProductReviews.Stars.IsPopup = true;
            //model.ProductControllerData.ProductReviews.Stars.Url = model.Url;
            html = Vendd.Handlebars.parse("productDetailsPopup", model);
            $wrapper.attr('data-parent-id', model.ParentProductId);
            $wrapper.attr('data-selected-id', model.SelectedProductId);
            $wrapper.attr('data-path', model.PathChecksum);
        } else {
            var state = Vendd.Product.Controller.getState();
            state.selectedColorId = model.SelectedProductColorId;
            html = Vendd.Handlebars.parse("productDetails", model);
        }


        // Make Visible Availability Container
        //  if (model.AvailabilityActionId != 1) {
        $wrapper.find('.availability-container').addClass('visible');
        //  }

        // enable "add to wishlist"
        if (model.Dimensions.length >= 2) {
            $('.js-add-to-wishlist', '.x-product-details-ajax-buttons').removeClass('disabled');
        }

        onYouTubeIframeAPIReady();

        $('.x-control.x-review-stars[data-type="stars"]').each(function (i, wrapper) {

            var $wrapper = $(wrapper);

            var isRateMode = $wrapper.data('is-rate-mode');
            var ratingSummaryData = $wrapper.data('rating-summary');
            var ratingSummary = 0.00;

            if (typeof ratingSummaryData === 'string') {
                ratingSummary = parseFloat(ratingSummaryData.replace(",", "."));
            } else if (typeof ratingSummaryData === 'number') {
                ratingSummary = parseFloat(ratingSummaryData);
            }

            initStars(isRateMode, ratingSummary, $wrapper);
        });

        wrapper.bind();

        wrapper.loading(false);
    };

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.Changed, wrapper, function (envelope) {
        model = envelope.message.data.model;

        wrapper.update();
    });


    //show in cart message
    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, 'x-product-details', function (envelope) { 
        var data = envelope.message.data.Cart.Items;
        var id = $wrapper.data('parent-id');
        var $inCartMessage = $wrapper.find('.js-in-cart');

        $inCartMessage.hide();

        for (var j = 0; j < data.length; j++) {
            if (id === data[j].ProductId) {
                $inCartMessage.show();
            }
        }
    });
    
    wrapper.bind();

    var funcCookiesEnabled = true;
    if (window.ConsentsManager) {
        funcCookiesEnabled = window.ConsentsManager.cookiesStatus.functionalityCookies;
    }

    if (LhApp.Context.LastViewedProducts != undefined && funcCookiesEnabled) {
        if (LhApp.Context.LastViewedProducts.LastViewedProductsIsActive) {
            var expirationDays = LhApp.Context.LastViewedProducts.LastViewedProductsExpirationDays;
            var productNumber = LhApp.Context.LastViewedProducts.LastViewedProductsNumber;
            var productId = LhApp.Context.Item.Id;

            var products = Cookies.get("LastViewedProducts") || "";
            var productsArray = _.reject(products.split(","), function (el) { return el == productId || el == ""; });
            productsArray.unshift(productId);
            var cookieValue = (_.first(productsArray, productNumber)).join(",");
            var expireDate = new Date();
            expireDate.setTime(expireDate.getTime() + expirationDays * 24 * 60 * 60 * 1000);
            Cookies.set("LastViewedProducts", cookieValue, { secure: LhApp.Context.Request.IsSecure, expires: expireDate, samesite: 'Lax' });
        }
    }

});

function scrollToSection() {
    var $container = $('.anchors-container');
    var $anchor = $('.anchor', $container);

    $anchor.click(function () {
        var $thisAnchor = $(this);
        var $tabIndex = $thisAnchor.attr('tab-index');
        var $sectionToScroll = $('.pd-area[tab-index="' + $tabIndex + '"]');
        var $headerHeight = $('.header-region').height() + 12;

        if ($(window).width() > 959) {
            if (!$thisAnchor.hasClass('selected')) {
                $anchor.removeClass('selected');
                $thisAnchor.addClass('selected');
            }
        } 

        if ($(window).width() > 959) {
            $('html, body').animate({ scrollTop: $sectionToScroll.offset().top - ($headerHeight + 60) }, 400);
        } else {
            $('html, body').animate({ scrollTop: $sectionToScroll.offset().top - $headerHeight }, 400);
        }
        
    });

    $(window).scroll(_.throttle(resetAnchors, 100));

}

function resetAnchors() {
    var $container = $('.anchors-container');
    var $anchor = $('.anchor', $container);

    if ($(window).width() > 959) {
        if ($(window).scrollTop() == 0) {
            $anchor.removeClass('selected');
            $anchor.first().addClass('selected');
        }
    } 
    
} 